<!-- 抖音商户收益弹窗 -->
<template>
    <el-dialog title="抖音商户收益" :visible.sync="showPop" width="800px" @close="$emit('input',false)">
        <div class="pop-box">
            <el-table :data="tableList" :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }" >
                <div slot="empty">
                    <img :src="require(`@/assets/image/empty.png`)" style="width: 100%; padding: 20px 0 0" />
                </div>
                <el-table-column
                    :label="item.label"
                    :prop="item.prop"
                    :width="item.width"
                    v-for="(item, index) in headerList"
                    :key="index"
                >
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            tableList: {
                type: Array,
                default: () => []
            }
        },
        data(){
            return {
                showPop: false,
                headerList: [
                    {
                        prop: "account",
                        label: "抖音商户号",
                    },
                    {
                        prop: "income",
                        label: "收益金额",
                    }
                ]
            }
        },
        watch: {
            value(nval) {
                this.showPop = nval
            }
        }
    }
</script>

<style lang="less" scoped>

</style>